import React from 'react';

const TimeRangeSelector = ({ selectedRange, onRangeChange }) => {
  const timeRanges = [
    { key: '7d', label: '7 Days' },
    { key: '30d', label: '30 Days' },
    { key: '90d', label: '90 Days' },
    { key: '1y', label: '1 Year' }
  ];

  return (
    <div className="flex space-x-1 bg-gray-100 rounded-lg p-1">
      {timeRanges.map(range => (
        <button
          key={range.key}
          onClick={() => onRangeChange(range.key)}
          className={`px-3 py-1 text-sm font-medium rounded-md transition-colors ${
            selectedRange === range.key
              ? 'bg-white text-blue-600 shadow-sm'
              : 'text-gray-600 hover:text-gray-900'
          }`}
        >
          {range.label}
        </button>
      ))}
    </div>
  );
};

export default TimeRangeSelector;
